// https://codepen.io/ciaranhan/pen/LvgQYy
import { ChartColors } from '../../../theme/tokens';

const normalLegend = {
  enabled: true,
  align: 'left',
  itemStyle: {
    fontSize: '0.7em',
  },
};

const base = (formatMetric) => {
  return {
    accessibility: {
      enabled: false,
    },
    chart: {
      styledMode: false,
      backgroundColor: 'transparent',
    },
    scrollbar: {
      enabled: false,
    },
    rangeSelector: {
      enabled: false,
    },
    navigator: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      useHTML: true,
      align: 'left',
      style: {
        color: 'var(--color-brand-dark)',
      },
    },
    xAxis: [],
    yAxis: [],
    exporting: {
      enabled: false,
    },

    tooltip: {
      shadow: {
        color: 'black',
        opacity: 0.04,
        offsetY: 3,
      },
      pointFormatter: function () {
        const seriesname = this.series.name;
        const value = formatMetric({
          metricId: this.series.userOptions.metricId,
          value: this.y,
        });

        // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables
        // This color will need dark mode handling via Highcharts theme system
        return `<span style="color:${this.color}">● </span><b><span style="color: var(--color-text-muted);">${seriesname}</span><b> ${value}</b><br/>`;
      },
      borderRadius: 8,
      padding: 12,
      shared: true,
      outside: true,
      split: false,
      backgroundColor: 'var(--color-tooltip-bg)',
      style: {
        color: 'var(--color-tooltip-text)',
      },
      borderColor: 'var(--color-border-secondary)',
      shadowOpacity: 0.05,
      borderWidth: 1,
    },
    legend: normalLegend,
    colors: ChartColors,
  };
};

export default base;
